import axios from 'axios'
import NProgress from 'nprogress/nprogress.js'
import Promise from 'bluebird'

require('es6-promise').polyfill()

export function publicCandidateHasErrored(bool) {
	return {
		type: 'PUBLIC_CANDIDATE_HAS_ERRORED',
		hasErrored: bool
	}
}

export function publicCandidateIsLoading(bool) {
	return {
		type: 'PUBLIC_CANDIDATE_IS_LOADING',
		isLoading: bool
	}
}

export function publicCandidateGetVideoSuccess(publicCandidate) {
	return {
		type: 'PUBLIC_CANDIDATE_GET_VIDEO_SUCCESS',
		publicCandidate
	}
}

export function publicCandidateGetVideo(hashVideoId) {
	return (dispatch) => {
		dispatch(publicCandidateIsLoading(true))

		return new Promise((resolve, reject) => {
			NProgress.start()
			axios({
				url: `/public/candidates/video/${hashVideoId}/filter`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then((response) => {
				let publicCandidate = response.data
				dispatch(publicCandidateGetVideoSuccess(publicCandidate))
				dispatch(publicCandidateIsLoading(false))

				NProgress.done()
			})
			.catch((error) => {
				reject(error)

				NProgress.done()

				console.error(error)

				dispatch(publicCandidateHasErrored(true))
			})
		})
	}
}

export function publicCandidateGetVideoAsync(publicCandidate) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(publicCandidateGetVideoSuccess(publicCandidate)))
		})
	}
}
